import { Box, Grid2 } from "@mui/material";
import { FC } from "react";
import EventCard from "./EventCard";
import { useEventContext } from "../../providers/EventProvider";
import { ReEvent } from "../../interfaces/types";

// Define the EventOverview functional component
const EventOverview: FC = () => {
  // Get the events from the event context
  const { events } = useEventContext();

  return (
    <Box data-testid="event-overview"
      sx={{
        display: "flex",
        flexDirection: { xs: "column", md: "column", lg: "row" },
        paddingLeft: 10,
        paddingRight: 10,
        margin: 10,
        justifyContent: "space-around",
      }}
    >
      {/* Render a grid container to display the event cards */}
      <Grid2 container spacing={10} justifyContent="center">
        {/* Map through the events and render an EventCard for each event */}
        {events?.map((event: ReEvent) => (
          <EventCard key={event.id} event={event} data-testid="event-card"/>
        ))}
      </Grid2>
    </Box>
  );
};

export default EventOverview;
